import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PricesDataService, PricesColumnsService } from '../../../services';
import { Price, PricesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-price-details',
  templateUrl: './price-details.component.html',
  styleUrls: ['./price-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PriceDetailsComponent implements OnInit, OnDestroy {

  public price: Price = {};
  public prices: Price[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pricesDataService: PricesDataService,
    private pricesColumnsService: PricesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Price - Details');
        this.getPrice(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.price !== 'undefined') {
      this.price = this.dynamicDialogConfig.data.price;
    }
    this.columns = this.pricesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPrice(id: number): void {
    this.isLoading = true;
    this.pricesDataService.getPrice(id).subscribe((response: Price|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.price = response;
      }
    });
  }

  list() {
    this.router.navigate(['/prices']);
  }

  add() {
    this.router.navigate(['/prices/add']);
  }

  edit() {
    this.router.navigate(['/prices/edit/' + this.price.id]);
  }

}
@Component({
  selector: 'app-price-details',
  templateUrl: './price-details.component.html',
  styleUrls: ['./price-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPriceDetailsComponent extends PriceDetailsComponent {
}

